import React from 'react';
import { useTranslation } from 'react-i18next';
import { Outlet } from 'react-router-dom';
import TabsWithTablesLayout from 'src/components/Layout/TabsWithTablesLayout';
import { useTenantContext } from 'src/context/useTenantContext';

interface AccountingPageProps {}

const AccountingPage = React.memo((_: AccountingPageProps) => {
  const { t } = useTranslation();
  const { buildPath } = useTenantContext();
  const routes = [
    {
      label: t('common.allTransactions'),
      url: buildPath('accounting/transactions'),
    },
    {
      label: t('common.incomes'),
      url: buildPath('accounting/incomes'),
    },
    {
      label: t('common.expenses'),
      url: buildPath('accounting/expenses'),
    },
    {
      label: t('common.investments'),
      url: buildPath('accounting/investments'),
    },
  ];

  return (
    <TabsWithTablesLayout
      homeUrl={'/dashboard/accounting'}
      mainPageUrl={'/accounting/transactions'}
      routes={routes}
      title={t('common.accounting')}
    >
      <Outlet />
    </TabsWithTablesLayout>
  );
});

export default AccountingPage;
